import { defineMessages } from 'react-intl';

export const landingMessages = defineMessages({
    'landing.title': {
        id: 'landing.title',
        defaultMessage: 'Welcome to Calm Health',
        description: 'Title for the landing page.',
    },
    'landing.welcome_description': {
        id: 'landing.welcome_description',
        defaultMessage:
            'Unlock the benefits of Calm Health. We’ll be your guide to a better relationship with your mental and physical health. Your Calm Health account is available to you at no additional cost as part of your health benefits.',
        description:
            'Description for the landing page introducing the app and the benefits.',
    },
    'landing.hero_image': {
        id: 'landing.hero_image',
        defaultMessage:
            'Jasper Lake in Jasper National Park, Alberta, Canada, surrounded by snow-capped mountains and lush forests.',
        description: 'Alt text for the hero image on the landing page.',
    },
    'landing.intro_video_fallback_image': {
        id: 'landing.intro_video_fallback_image',
        defaultMessage: 'Mel Mah sitting in a chair.',
        description: 'Alt text for the fallback image for the intro video.',
    },
    'landing.meet_contributors': {
        id: 'landing.meet_contributors',
        defaultMessage: 'Meet our Program Contributors',
        description:
            'Text introducing the contributors to the Calm Health content.',
    },
    'landing.meet_contributors_description': {
        id: 'landing.meet_contributors_description',
        defaultMessage:
            'Calm Health’s programs are written by psychologists and are based on techniques that are proven to work, including cognitive behavioral therapy, acceptance and commitment therapy, and dialectical behavioral therapy.',
        description:
            'Text introducing the expertise of the contributors to the Calm Health content.',
    },
    'landing.meet_narrators': {
        id: 'landing.meet_narrators',
        defaultMessage: 'Meet our Narrators',
        description:
            'Text Introducing the narrators of the Calm Health content.',
    },
    'landing.meet_narrators_description': {
        id: 'landing.meet_narrators_description',
        defaultMessage:
            'Our digital programs are narrated in a friendly, approachable way by the familiar voices of Calm that you know and trust.',
        description:
            'Text describing the style narrators of the Calm Health content.',
    },
    'landing.get_started': {
        id: 'landing.get_started',
        defaultMessage: 'Get Started',
        description: 'Button text to get started with the Calm Health app.',
    },
    'landing.scan_qr_code': {
        id: 'landing.scan_qr_code',
        defaultMessage:
            'Scan the QR code to easily download the Calm Health app.',
        description:
            'Prompt directing the user to download the Calm Health app by using the QR code.',
    },
    'landing.log_in': {
        id: 'landing.log_in',
        defaultMessage: 'Log In',
        description: 'Button text to log in to the Calm Health app.',
    },
    'landing.log_in_full': {
        id: 'landing.log_in_full',
        defaultMessage: 'Log in with your Calm account',
        description:
            'Button text to log in to the Calm Health app through a general Calm acocunt.',
    },
    'landing.sign_in': {
        id: 'landing.sign_in',
        defaultMessage: 'Sign In',
        description: 'Button text to sign in to the Calm Health app.',
    },
    'landing.sign_up': {
        id: 'landing.sign_up',
        defaultMessage: 'Sign Up',
        description: 'Button text to sign up for the Calm Health app.',
    },
    'landing.sign_up_full': {
        id: 'landing.sign_up_full',
        defaultMessage: 'Create a Calm Account',
        description: 'Button text for creating a Calm account.',
    },
    'landing.qr_code_alt': {
        id: 'landing.qr_code_alt',
        defaultMessage: 'QR code to download Calm Health',
        description:
            'Alt text for the QR code image, used to download the Calm Health app.',
    },
    'landing.account_sign_in': {
        id: 'landing.account_sign_in',
        defaultMessage: 'Your account sign in:',
        description:
            'Description of the id of the account used for signing in.',
    },
    'landing.apple_id': {
        id: 'landing.apple_id',
        defaultMessage: 'Apple ID',
        description: "Label for the id of the user's Apple account.",
    },
    'landing.did_you_know': {
        id: 'landing.did_you_know',
        defaultMessage: 'Did you know?',
        description: 'Text introducing a fact about mental health.',
    },
    'landing.half_of_adults': {
        id: 'landing.half_of_adults',
        defaultMessage: '1 in 2 Adults',
        description: 'Half of all adults.',
    },
    'landing.half_of_adults_description': {
        id: 'landing.half_of_adults_description',
        defaultMessage:
            'Will experience a mental health issue in their lifetime.',
        description: 'Fact about mental health.',
    },
    'landing.half_of_americans': {
        id: 'landing.half_of_americans',
        defaultMessage: '50% of Americans',
        description: 'Half of all Americans.',
    },
    'landing.half_of_americans_description': {
        id: 'landing.half_of_americans_description',
        defaultMessage:
            'Will meet the criteria for a diagnosable mental health condition some time in their life.',
        description: 'Fact about mental health.',
    },
    'landing.depression': {
        id: 'landing.depression',
        defaultMessage: '264 Million',
        description: 'Count of people with depression.',
    },
    'landing.depression_description': {
        id: 'landing.depression_description',
        defaultMessage: 'People suffer from depression worldwide.',
        description: 'Fact about mental health.',
    },
    'landing.mental_health_citation': {
        id: 'landing.mental_health_citation',
        defaultMessage:
            'Mental Health By the Numbers | NAMI: National Alliance on Mental Illness',
        description:
            'Attribution for the facts about mental health on the landing page.',
    },
    'landing.ready_to_improve': {
        id: 'landing.ready_to_improve',
        defaultMessage: 'Ready to prioritize your mental and physical health?',
        description:
            'Question with the goal of getting users to sign up for the Calm Health app.',
    },
    'landing.ready_to_improve_description': {
        id: 'landing.ready_to_improve_description',
        defaultMessage:
            'Taking good care of your mental health has never been more important. Calm Health can help.',
        description:
            'Description of the benefits of using the Calm Health app.',
    },
    'landing.support_your_mental': {
        id: 'landing.support_your_mental',
        defaultMessage: 'Support Your Mental Health',
        description: 'Prompt to get users to sign up for the Calm Health app.',
    },
    'landing.support_your_mental_description': {
        id: 'landing.support_your_mental_description',
        defaultMessage:
            'The Calm Health app offers personalized plans to provide support for a range of health conditions, life experiences, and mental health challenges.',
        description:
            'Descritpion of the programs in the Calm Health app and the situations and benefits they support.',
    },
    'landing.track_your_progress': {
        id: 'landing.track_your_progress',
        defaultMessage: 'Track Your Journey',
        description:
            'Title for the section of the landing page that describes how users can track their progress.',
    },
    'landing.track_your_progress_description': {
        id: 'landing.track_your_progress_description',
        defaultMessage:
            'Calm Health makes it easy to check in, see how you’re doing, and get relevant recommendations for next steps. ',
        description: 'Value of the tracking feature in the Calm Health app.',
    },
    'landing.feel_better': {
        id: 'landing.feel_better',
        defaultMessage: 'Feel Better',
        description:
            'Title for the section of the landing page that describes how users can improve their mood.',
    },
    'landing.feel_better_description': {
        id: 'landing.feel_better_description',
        defaultMessage:
            'Explore Calm Health’s programs at your own pace and learn to better support anxiety and depression symptoms, sleep better and stress less, and make positive changes to your lifestyle.',
        description: 'Description of the benefits of the Calm Health app.',
    },
    'landing.ready_get_started': {
        id: 'landing.ready_get_started',
        defaultMessage: 'Ready to get started?',
        description: 'Propt to get users to sign up for the Calm Health app.',
    },
    'landing.ready_get_started_description': {
        id: 'landing.ready_get_started_description',
        defaultMessage:
            'Download the Calm Health app, create your account, and answer a few simple questions to help us understand how you’re feeling. You’ll get instant recommendations for the Calm Health programs that will be the most helpful for you.\n\nDeveloped by psychologists, you can explore our programs at your own pace, in any order you like. Your personal information will always be kept secure.',
        description:
            'Description of the process of signing up for the Calm Health app.',
    },
    'landing.company': {
        id: 'landing.company',
        defaultMessage: 'Company',
        description: 'Footer link for the Calm company information.',
    },
    'landing.overview': {
        id: 'landing.overview',
        defaultMessage: 'Overview',
        description: 'Footer link for the Calm Health app.',
    },
    'landing.employees_and_payers': {
        id: 'landing.employees_and_payers',
        defaultMessage: 'Employees & Payers',
        description:
            'Footer link for information for insurance employees and payers.',
    },
    'landing.providers': {
        id: 'landing.providers',
        defaultMessage: 'Providers',
        description: 'Footer link for information for insurance providers.',
    },
    'landing.press': {
        id: 'landing.press',
        defaultMessage: 'Press',
        description: 'Footer link for press information.',
    },
    'landing.solutions': {
        id: 'landing.solutions',
        defaultMessage: 'Solutions',
        description: 'Footer section for the Calm Health app solutions.',
    },
    'landing.calm_business': {
        id: 'landing.calm_business',
        defaultMessage: 'Calm Business',
        description: 'Footer link for the Calm for Business product.',
    },
    'landing.calm_health': {
        id: 'landing.calm_health',
        defaultMessage: 'Calm Health',
        description: 'Footer link for the Calm Health app.',
    },
    'landing.more_information': {
        id: 'landing.more_information',
        defaultMessage: 'More Information',
        description:
            'Footer link for more information about the Calm Health app.',
    },
    'landing.request_information': {
        id: 'landing.request_information',
        defaultMessage: 'Request Information',
        description:
            'Footer link for requesting more information about the Calm Health app.',
    },
    'landing.careers': {
        id: 'landing.careers',
        defaultMessage: 'Careers',
        description: 'Footer link for job opportunities at Calm.',
    },
    'landing.tos': {
        id: 'landing.tos',
        defaultMessage: 'Terms',
        description: 'Footer link for the terms of service.',
    },
    'landing.privacy': {
        id: 'landing.privacy',
        defaultMessage: 'Privacy',
        description: 'Footer link for the privacy policy.',
    },
    'landing.privacy_choices': {
        id: 'landing.privacy_choices',
        defaultMessage: 'Your Privacy Choices',
        description: 'Footer link for privacy choices.',
    },
    'landing.cookies': {
        id: 'landing.cookies',
        defaultMessage: 'Cookies',
        description: 'Footer link for the cookie policy.',
    },
    'landing.consumerHealthData': {
        id: 'landing.consumerHealthData',
        defaultMessage: 'Consumer Health Data',
        description: 'Footer link for consumer health data.',
    },
    'landing.faq': {
        id: 'landing.faq',
        defaultMessage: 'FAQ',
        description: 'Freuently asked questions about the Calm Health app.',
    },
    'landing.resources': {
        id: 'landing.resources',
        defaultMessage: 'Resources',
        description: 'Links to other resources related to the Calm Health app.',
    },
    'landing.linked_in': {
        id: 'landing.linked_in',
        defaultMessage: 'LinkedIn',
        description: 'Footer link to the Calm LinkedIn page.',
    },
    'landing.youtube': {
        id: 'landing.youtube',
        defaultMessage: 'YouTube',
        description: 'Footer link to the Calm YouTube page.',
    },
    'landing.card.anxiety_survival_guide.title': {
        id: 'landing.card.anxiety_survival_guide.title',
        defaultMessage: 'Anxiety Survival Guide',
        description: 'Link to the Anxiety Survival Guide resource.',
    },
    'landing.card.anxiety_survival_guide.image_alt': {
        id: 'landing.card.anxiety_survival_guide.image_alt',
        defaultMessage: 'An image of a person with a cup of tea',
        description:
            'Alt text for the image of the Anxiety Survival Guide resource.',
    },
    'landing.card.better_sleep.title': {
        id: 'landing.card.better_sleep.title',
        defaultMessage: 'Better Sleep',
        description: 'Title for the Better Sleep program.',
    },
    'landing.card.better_sleep.category_title': {
        id: 'landing.card.better_sleep.category_title',
        defaultMessage: 'Masterclass',
        description: 'Label for the category of the Better Sleep program.',
    },
    'landing.card.better_sleep.image_alt': {
        id: 'landing.card.better_sleep.image_alt',
        defaultMessage:
            'A closeup of a smiling person under the covers in a bed',
        description: 'Alt text for the image of the Better Sleep program.',
    },
    'landing.card.navigating_depression.title': {
        id: 'landing.card.navigating_depression.title',
        defaultMessage: 'Navigating Depression with Practical Tools',
        description: 'Program title for Navigating Depression.',
    },
    'landing.card.navigating_depression.image_alt': {
        id: 'landing.card.navigating_depression.image_alt',
        defaultMessage: 'A person walking along a lake',
        description:
            'Alt text for the image of the Navigating Depression program.',
    },
    'landing.card.night_train.title': {
        id: 'landing.card.night_train.title',
        defaultMessage: 'The Nordland Night Train',
        description: 'Title for the Night Train Sleep Story.',
    },
    'landing.card.night_train.category_title': {
        id: 'landing.card.night_train.category_title',
        defaultMessage: 'Sleep Story',
        description: 'Category for the Night Train Sleep Story.',
    },
    'landing.card.night_train.image_alt': {
        id: 'landing.card.night_train.image_alt',
        defaultMessage: 'An image of a train track going off into the dusk.',
        description: 'Alt text for the image of the Night Train Sleep Story.',
    },
    'landing.card.reduce_stress.title': {
        id: 'landing.card.reduce_stress.title',
        defaultMessage: 'Reduce your stress with CSBR',
        description:
            'Title introducig how the user can use the CSBR program to reduce stress.',
    },
    'landing.card.reduce_stress.image_alt': {
        id: 'landing.card.reduce_stress.image_alt',
        defaultMessage: 'An image of a person closing their eyes in a field',
        description: 'Alt text for the image of the CSBR program.',
    },
    'landing.card.reboot.title': {
        id: 'landing.card.reboot.title',
        defaultMessage: '60 Second Reboot',
        description:
            'Card title for the short meditation program to bring users back to a relaxed state.',
    },
    'landing.card.reboot.category_title': {
        id: 'landing.card.reboot.category_title',
        defaultMessage: 'Meditation',
        description: 'Category for the 60 Second Reboot program.',
    },
    'landing.card.reboot.image_alt': {
        id: 'landing.card.reboot.image_alt',
        defaultMessage: 'An image of a person looking at a computer',
        description: 'Alt text for the image of the 60 Second Reboot program.',
    },
    'landing.survey_results': {
        id: 'landing.survey_results',
        defaultMessage:
            "Two sliding scales show the results for Anxiety and Depression. The anxiety score is a 'Minimal' score of 1 and the depression score is a 'Minimal' score of 3.",
        description: 'Description of how the survey results are displayed.',
    },
    'landing.depression_graph': {
        id: 'landing.depression_graph',
        defaultMessage:
            "A graph showing the results of depression screenings 5-10 and possible scores from 0-27. The current score is a 'Moderate' score of 13.",
        description:
            'Description of the graph showing the results of the depression screening.',
    },
    'landing.app_feature_program': {
        id: 'landing.app_feature_program',
        defaultMessage:
            "A screenshot of the Calm Health mobile app 'Preparing for Therapy' program.",
        description:
            'Alt text for the image of the Preparing for Therapy program.',
    },
    'landing.app_feature_player': {
        id: 'landing.app_feature_player',
        defaultMessage:
            "A screenshot of the Calm Health mobile app 'Is Therapy Right For Me?' session player.",
        description:
            'Alt text for the image of the Is Therapy Right For Me? session player.',
    },
    'landing.registration_completed': {
        id: 'landing.registration_completed',
        defaultMessage: 'Your registration has been successfully completed.',
        description:
            'Text confirming that the user has successfully registered for the Calm Health app.',
    },
    'landing.registration_completed_description': {
        id: 'landing.registration_completed_description',
        defaultMessage:
            'Now you can get started by downloading the Calm Health app and logging in to the account you just created.',
        description:
            'Description of the next steps after registering for the Calm Health app.',
    },
    'landing.what_happens_next': {
        id: 'landing.what_happens_next',
        defaultMessage: 'What to expect next',
        description:
            'Title for the section that describes what happens after the user registers for the Calm Health app.',
    },
    'landing.what_happens_next_description': {
        id: 'landing.what_happens_next_description',
        defaultMessage: 'When you download the app, you can:',
        description:
            'Title for the section describing what you can do with the Calm Health app.',
    },
    'landing.track_progress': {
        id: 'landing.track_progress',
        defaultMessage: 'Track Your Progress',
        description:
            'Description of the feature that allows users to track their progress in the Calm Health app.',
    },
    'landing.customized_recommendations': {
        id: 'landing.customized_recommendations',
        defaultMessage: 'Get Customized Recommendations',
        description:
            'Description of the feature that provides personalized recommendations in the Calm Health app.',
    },
    'landing.clinical_programs': {
        id: 'landing.clinical_programs',
        defaultMessage: 'Join Clinical Programs Created by Experts',
        description:
            'Description of how users can join programs within the Calm Health app.',
    },
    'landing.mindfulness': {
        id: 'landing.mindfulness',
        defaultMessage: 'Begin a Mindfulness Practice',
        description:
            'Description of how users can start a mindfulness practice in the Calm Health app.',
    },
    'landing.setup_web': {
        id: 'landing.setup_web',
        defaultMessage:
            'You may also set up your account on your computer and take the mental health screening. Your Plan will be ready when you log in',
        description:
            'Section for users who want to set up their account on a computer.',
    },
    'landing.pause_intro_video': {
        id: 'landing.pause_intro_video',
        defaultMessage: 'Pause intro video',
        description: 'Button to pause the intro video on the landing page.',
    },
    'landing.resume_intro_video': {
        id: 'landing.resume_intro_video',
        defaultMessage: 'Resume intro video',
        description:
            'Button text to resume the intro video on the landing page.',
    },
});

export default landingMessages;
